import { render, staticRenderFns } from "./task_step1.vue?vue&type=template&id=4ede57b0&scoped=true"
import script from "./task_step1.vue?vue&type=script&lang=js"
export * from "./task_step1.vue?vue&type=script&lang=js"
import style0 from "./task_step1.vue?vue&type=style&index=0&id=4ede57b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../home/zarzar/Documents/public-solution/bis-office/web/auftragsbuch/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ede57b0",
  null
  
)

export default component.exports